// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__13IQB","dragIcon":"SortableItem_dragIcon__3hYyt","disabled":"SortableItem_disabled__3bncy"};